import { render, staticRenderFns } from "./ReinitiateAccountTopUpBtn.vue?vue&type=template&id=76bf3f42&scoped=true&"
import script from "./ReinitiateAccountTopUpBtn.vue?vue&type=script&lang=js&"
export * from "./ReinitiateAccountTopUpBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bf3f42",
  null
  
)

export default component.exports